import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import SeccionesView from './SeccionesView';
import * as ROUTES from '../../../router/Routes';

const SeccionesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.secciones}
      routes={[ROUTES.controlEstudios]}
    >
      <SeccionesView />
    </ContainerTemplate>
  );
};

export default SeccionesModule;
